import {useState} from "react";

/**
 * Metodo para almacenar obtener y almacenar datos en el localstorage
 * @param key
 * @param defaultValue
 * @returns {(any|setLocalStoreValue)[]}
 */
export function useLocalStorage(key, defaultValue) {
    const [storedValue, setStoreValue] = useState(() => {
        try {
            const item = localStorage.getItem(key)
            return item ? JSON.parse(item) : defaultValue
        } catch (e) {
            return defaultValue;
        }
    });
    const setLocalStoreValue = value => {
        try {
            setStoreValue(value)
            localStorage.setItem(key, JSON.stringify(value))
        }catch (e) {
            console.log(e)
        }
    }
    return [storedValue, setLocalStoreValue]
}